import { render, staticRenderFns } from "./CollapsibleList.vue?vue&type=template&id=34a1ddd4&scoped=true&"
import script from "./CollapsibleList.vue?vue&type=script&lang=js&"
export * from "./CollapsibleList.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleList.vue?vue&type=style&index=0&id=34a1ddd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1ddd4",
  null
  
)

export default component.exports